export default __webpack_public_path__ + "static/media/k-new.8b04c544.gif";